// extracted by mini-css-extract-plugin
module.exports = {"AuthContainer":"Login_AuthContainer__2FeMV","AuthPage":"Login_AuthPage__13gdV"};